import React, { useState, useMemo } from "react";
import { CheckBoxInput } from "../common/Buttons";
import { Tooltip, Popover } from "antd";
import { IconExclamation, IconHistory, XIcon } from "../Layout/Icons";
import { AiOutlineExclamation } from "react-icons/ai";
import styled from "styled-components";
import {
  numberRound,
  prettyDateFormat,
  relDiff,
  returnEuroString,
} from "../../helpers/Utils";
import TableUi from "../Layout/TableUI";
import moment from "moment";
import ImumProductTagPopover from "./ImumProductTagPopover";
import { BlockSquare } from "../common/StyledComponents";
import ImumTableTD from "./ImumTableTD";
import ImumOldPricePreview from "./ImumOldPricePreview";
import ImumNewPriceChange from "./ImumNewPriceChange";
import { removeDuplicates } from "../../helpers/array";
import { IconImumClock } from "../Layout/Icons";
import dayjs from "dayjs";

const ImumToAkeneoColumn = ({
  active,
  setActive,
  id,
  product_code,
  product_name,
  imum_category,
  brand,
  ean_code,
  mpn,
  columns,
  updated_at,
  checked,
  setChecked,
  lastBookElementRef,
  showColumnAvailable,
  new_prices,
  old_prices,
  cheapest,
  today_supplier_prices,
  cost,
  price_change_history,
  countriesAreDisplayed,
  active_lt,
  active_lv,
  active_ee,
  active_fi,
  change_lt,
  change_lv,
  change_ee,
  change_fi,
  margin_lt,
  margin_lv,
  margin_ee,
  margin_fi,
  cheapest_lt,
  cheapest_lv,
  cheapest_ee,
  cheapest_fi,
  cheapest_market_lt,
  cheapest_market_lv,
  cheapest_market_ee,
  cheapest_market_fi,
  min_market_margin_ee,
  min_market_margin_fi,
  min_market_margin_lt,
  min_market_margin_lv,
  imum_product_tags,
  tag_ids,
  columnWidthMain,
  imum_export_logs,
  failed,
  imum_rules,
  added_to_xml,
  received_from_imum,
}) => {
  const values = useMemo(() => {
    // new
    const valuess = {
      lt: {},
      ee: {},
      lv: {},
      fi: {},
      changed_price: false,
    };
    //  new price
    new_prices.forEach((d) => {
      if (!valuess.changed_price && d.changed_price) {
        valuess.changed_price = true;
      }
      valuess[d.country.toLowerCase()] = {
        ...valuess[d.country.toLowerCase()],
        new_price: d.price,
        id: d.id || null,
        export_date: d.export_date || null,
        export_status: d.export_status,
        imum_rule: d.imum_rule_id
          ? imum_rules?.find((s) => s.value == d.imum_rule_id)?.label
          : null,
      };
    });

    price_change_history.forEach((d) => {
      const isToday =
        moment().format("YYYY-MM-DD") ==
        moment(d.created_at).format("YYYY-MM-DD");

      if (!isToday) return;
      // console.log({ isToday });

      const updated_at = `${prettyDateFormat(d.created_at)} - ${
        d.full_name
      } - ${numberRound(d.price)}`;
      if (d.country.toLowerCase().includes("_ee")) {
        if (valuess.ee.updated_at) return;
        valuess.ee = {
          ...valuess.ee,
          updated_at,
        };
      } else if (d.country.toLowerCase().includes("_lv")) {
        if (valuess.lv.updated_at) return;
        valuess.lv = {
          ...valuess.lv,
          updated_at,
        };
      } else if (d.country.toLowerCase().includes("_fi")) {
        if (valuess.fi.updated_at) return;
        valuess.fi = {
          ...valuess.fi,
          updated_at,
        };
      } else {
        if (valuess.lt.updated_at) return;
        valuess.lt = {
          ...valuess.lt,
          updated_at,
        };
      }
    });

    cheapest.forEach((d) => {
      valuess[d.country.toLowerCase()] = {
        ...valuess[d.country.toLowerCase()],
        cheapest_price: d.price,
        cheapest:
          today_supplier_prices.find(
            (s) =>
              d.price == s.price &&
              s.category.toLowerCase() == d.country.toLowerCase()
          )?.shop || "-",
      };
    });

    old_prices.forEach((d) => {
      let new_obj = {
        ...valuess[d.country.toLowerCase()],
        old_price: d.price,
        price_updated_at: d.price_updated_at
          ? prettyDateFormat(d.price_updated_at)
          : null,
      };
      if (+new_obj.new_price < +d.price) {
        const suspectful_price_diff = relDiff(+new_obj.new_price, +d.price);
        if (suspectful_price_diff >= 10)
          new_obj.suspectful_price = +numberRound(suspectful_price_diff);
      }

      valuess[d.country.toLowerCase()] = new_obj;
    });

    // OOS setter
    // const ossFuncOfArray = (category) => {
    //   let arr = today_supplier_prices.filter((d) => d.category == category);
    //   if (arr.length == 0) return true;
    //   return arr.every((d) => !d.active);
    // };
    // valuess.oos = [];
    // if (ossFuncOfArray("LT")) valuess.oos.push("LT");
    // if (ossFuncOfArray("LV")) valuess.oos.push("LV");
    // if (ossFuncOfArray("EE")) valuess.oos.push("EE");
    // if (ossFuncOfArray("FI")) valuess.oos.push("FI");

    valuess.related_ids = [
      valuess.lt.id,
      valuess.ee.id,
      valuess.lv.id,
      valuess.fi.id,
    ].map((d) => d);

    return valuess;
  }, [updated_at, imum_rules]);

  const inactive_check = useMemo(() => {
    const countries = ["LT", "LV", "EE", "FI"];
    const activeCountries = {
      LT: active_lt,
      LV: active_lv,
      EE: active_ee,
      FI: active_fi,
    };

    return countries.filter((country) => {
      if (window.identifier === "technorama" && country !== "LT") {
        return false;
      }
      return !activeCountries[country];
    });
  }, [active_lt, active_lv, active_ee, active_fi]);
  return (
    <tr className="align-middle tableColumn" ref={lastBookElementRef}>
      <TdProductTitle
        product_id={id}
        product_name={product_name}
        changed_price={values.changed_price}
        checked={checked}
        setChecked={setChecked}
        price_change_history={price_change_history}
        inactive={inactive_check}
        tag_ids={tag_ids}
        imum_product_tags={imum_product_tags}
        columnWidthMain={columnWidthMain}
      />
      {showColumnAvailable("SKU") && (
        <td className="align-middle">{product_code}</td>
      )}
      {showColumnAvailable("MPN") && (
        <td className="align-middle">{mpn || "-"}</td>
      )}
      {showColumnAvailable("EAN") && (
        <td className="align-middle">{ean_code || "-"}</td>
      )}
      {showColumnAvailable("Prod. cat.") && (
        <td className="align-middle">
          <nobr>{imum_category || "-"}</nobr>
        </td>
      )}
      {showColumnAvailable("Brand") && (
        <td className="align-middle">{brand || "-"}</td>
      )}
      {showColumnAvailable("Prime cost") && (
        <td className="align-middle">
          <nobr>{cost ? returnEuroString(cost) : "-"}</nobr>
        </td>
      )}
      {failed && showColumnAvailable("Failure") && (
        <td className="align-middle">
          {!!imum_export_logs.length && (
            <ImumExportLogs imum_export_logs={imum_export_logs} />
          )}
        </td>
      )}
      <td
        className="align-middle"
        style={{
          width: 30,
        }}
      >
        <div style={{ position: "relative" }}>
          <Tooltip
            placement="top"
            overlay={
              <div>
                <p className="m-0">
                  <span style={{ fontWeight: "600" }}>BB</span>:{" "}
                  {added_to_xml
                    ? dayjs(added_to_xml).format("YYYY-MM-DD HH:mm")
                    : "-"}
                </p>
                <p className="m-0">
                  <span style={{ fontWeight: "600" }}>IMUM</span>:{" "}
                  {received_from_imum
                    ? dayjs(received_from_imum).format("YYYY-MM-DD HH:mm")
                    : "-"}
                </p>
              </div>
            }
          >
            <div style={{ position: "absolute", right: "-20px", top: "-13px" }}>
              {IconImumClock()}
            </div>
          </Tooltip>
        </div>
      </td>
      {showColumnAvailable("Old price") && (
        <>
          <StyledTd country="LT" countriesAreDisplayed={countriesAreDisplayed}>
            <ImumOldPricePreview value={values.lt} />
          </StyledTd>
          <StyledTd country="LV" countriesAreDisplayed={countriesAreDisplayed}>
            <ImumOldPricePreview value={values.lv} />
          </StyledTd>
          <StyledTd country="EE" countriesAreDisplayed={countriesAreDisplayed}>
            <ImumOldPricePreview value={values.ee} />
          </StyledTd>
          <StyledTd country="FI" countriesAreDisplayed={countriesAreDisplayed}>
            <ImumOldPricePreview value={values.fi} />
          </StyledTd>
        </>
      )}
      {showColumnAvailable("New price") && (
        <>
          <ImumNewPriceChange
            active={active}
            setActive={setActive}
            country="LT"
            value={values.lt.new_price}
            id={values.lt.id}
            parent_id={id}
            countriesAreDisplayed={countriesAreDisplayed}
            old_price={values.lt.old_price}
            related_ids={values.related_ids}
            variables={values.lt}
          />
          <ImumNewPriceChange
            active={active}
            setActive={setActive}
            country="LV"
            value={values.lv.new_price}
            id={values.lv.id}
            parent_id={id}
            countriesAreDisplayed={countriesAreDisplayed}
            old_price={values.lv.old_price}
            related_ids={values.related_ids}
            variables={values.lv}
          />
          <ImumNewPriceChange
            active={active}
            setActive={setActive}
            country="EE"
            value={values.ee.new_price}
            id={values.ee.id}
            parent_id={id}
            countriesAreDisplayed={countriesAreDisplayed}
            old_price={values.ee.old_price}
            related_ids={values.related_ids}
            variables={values.ee}
          />
          <ImumNewPriceChange
            active={active}
            setActive={setActive}
            country="FI"
            value={values.fi.new_price}
            id={values.fi.id}
            parent_id={id}
            countriesAreDisplayed={countriesAreDisplayed}
            old_price={values.fi.old_price}
            related_ids={values.related_ids}
            variables={values.fi}
          />
        </>
      )}
      {showColumnAvailable("New margin") && (
        <>
          <CheapestDifference
            type="margin"
            country="LT"
            value={margin_lt}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            type="margin"
            country="LV"
            value={margin_lv}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            type="margin"
            country="EE"
            value={margin_ee}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            type="margin"
            country="FI"
            value={margin_fi}
            countriesAreDisplayed={countriesAreDisplayed}
          />
        </>
      )}
      {showColumnAvailable("New price competitor") && (
        <>
          <ImumTableTD
            country="LT"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_lt || "-"}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="LV"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_lv || "-"}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="EE"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_ee || "-"}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="FI"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_fi || "-"}</nobr>
          </ImumTableTD>
        </>
      )}
      {showColumnAvailable("Min market price") && (
        <>
          <ImumTableTD
            country="LT"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{values.lt.cheapest_price}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="LV"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{values.lv.cheapest_price}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="EE"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{values.ee.cheapest_price}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="FI"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{values.fi.cheapest_price}</nobr>
          </ImumTableTD>
        </>
      )}
      {showColumnAvailable("Min market markup") && (
        <>
          <CheapestDifference
            type="margin"
            country="LT"
            showZeroAsEmpty={true}
            value={min_market_margin_lt}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            type="margin"
            country="LV"
            showZeroAsEmpty={true}
            value={min_market_margin_lv}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            type="margin"
            country="EE"
            showZeroAsEmpty={true}
            value={min_market_margin_ee}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            type="margin"
            country="FI"
            showZeroAsEmpty={true}
            value={min_market_margin_fi}
            countriesAreDisplayed={countriesAreDisplayed}
          />
        </>
      )}
      {showColumnAvailable("New price competitor") && (
        <>
          <ImumTableTD
            country="LT"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_market_lt || "-"}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="LV"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_market_lv || "-"}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="EE"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_market_ee || "-"}</nobr>
          </ImumTableTD>
          <ImumTableTD
            country="FI"
            countriesAreDisplayed={countriesAreDisplayed}
          >
            <nobr>{cheapest_market_fi || "-"}</nobr>
          </ImumTableTD>
        </>
      )}
      {showColumnAvailable("Price change") && (
        <>
          <CheapestDifference
            country="LT"
            value={change_lt}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            country="LV"
            value={change_lv}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            country="EE"
            value={change_ee}
            countriesAreDisplayed={countriesAreDisplayed}
          />
          <CheapestDifference
            country="FI"
            value={change_fi}
            countriesAreDisplayed={countriesAreDisplayed}
          />
        </>
      )}
      <td />
      {showColumnAvailable("Store prices") &&
        columns
          .filter((fi) => fi.its_shop)
          .map((ec) => (
            !(countriesAreDisplayed && !countriesAreDisplayed.includes(ec.country)) &&
            <td className="align-middle text-align-center" key={ec.title + "_" + id + "_" + ec.country}>
              <FindShopPrice
                shop={ec.title}
                country={ec.country}
                data={today_supplier_prices}
                countriesAreDisplayed={countriesAreDisplayed}
              />
            </td>
          ))}
      <td></td>
    </tr>
  );
};

export default ImumToAkeneoColumn;

const TdProductTitle = ({
  product_id,
  product_name,
  changed_price,
  setChecked,
  checked,
  price_change_history,
  inactive,
  tag_ids,
  imum_product_tags,
  columnWidthMain,
}) => {
  const imum_product_tags_used = imum_product_tags.filter((d) =>
    tag_ids.includes(d.value)
  );

  return (
    <td
      className={`align-middle p-left`}
      style={{
        // paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      {changed_price && (
        <div className="position-relative">
          <Tooltip placement="left" title={"Changed price"}>
            <div
              className="position-absolute rounded-circle d-flex align-items-center justify-content-center"
              style={{
                left: "-16px",
                top: 34,
                // left: 0,
                // top: "50%",
                backgroundColor: "#0088BF",
                width: 15,
                height: 15,
                transform: "translate(0px, -50%)",
                zIndex: 10000000000000000,
              }}
            >
              <AiOutlineExclamation className="text-xs" color="#fff" />
            </div>
          </Tooltip>
        </div>
      )}
      <div
        style={{
          width: columnWidthMain,
          // textOverflow: "ellipsis",
          // overflow: "hidden",
        }}
      >
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            padding: "0.75rem 0.55rem 0.75rem 0",
          }}
        >
          <div
            className="flex-1"
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            <CheckBoxInput
              onChange={setChecked}
              checked={checked}
              text={
                <div
                  className="d-flex align-items-center"
                  // style={{
                  //   maxWidth: 230,
                  // }}
                >
                  {inactive.length > 0 && (
                    <Tooltip
                      placement="top"
                      title={`Inactive ${
                        window.identifier === "technorama"
                          ? "LT"
                          : inactive.join(", ")
                      }`}
                    >
                      <span
                        className="d-flex align-items-center justify-content-center  mr-2"
                        style={{
                          width: 16,
                          height: 16,
                          background: "rgba(217, 217, 217, 0.4)",
                          borderRadius: 30,
                          fontWeight: 600,
                          fontSize: 9,
                          color: "#C4C4C4",
                        }}
                      >
                        IN
                      </span>
                    </Tooltip>
                  )}
                  {imum_product_tags_used.map((d) => (
                    <Tooltip key={d.value} placement="top" title={d.label}>
                      <div className="mr-1">
                        <BlockSquare color={d.color} />
                      </div>
                    </Tooltip>
                  ))}
                  <div>{product_name}</div>
                </div>
              }
            />
          </div>
          <div>
            {price_change_history.length > 0 && (
              <PriceChangeHistory price_change_history={price_change_history} />
            )}

            <ImumProductTagPopover
              product_id={product_id}
              tag_ids={tag_ids}
              imum_product_tags={imum_product_tags}
            />
          </div>
        </div>
      </div>
    </td>
  );
};

const PriceChangeHistory = ({ price_change_history }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <Popover
      placement="right"
      title={
        <div className="d-flex align-items-center justify-content-between py-2">
          <div className="font-semi-bold text-base text-black">
            Price change history
          </div>
          <XIcon
            className="cursor-pointer text-black"
            onClick={() => setShowModal(false)}
          />
        </div>
      }
      content={
        showModal ? (
          <div>
            <TableUi
              hoverable={false}
              ths={["Country", "Date", "Price", "User"]}
            >
              {price_change_history.map((e, idx) => {
                return (
                  <TableUi.tr key={`${e.id || 0}_${idx}`}>
                    <TableUi.td className={"p-left"}>
                      {e.country.toUpperCase()}
                    </TableUi.td>
                    <TableUi.td>{prettyDateFormat(e.created_at)}</TableUi.td>
                    <TableUi.td>{numberRound(e.price)}</TableUi.td>
                    <TableUi.td className={"p-right"}>{e.full_name}</TableUi.td>
                  </TableUi.tr>
                );
              })}
            </TableUi>
          </div>
        ) : (
          ""
        )
      }
      trigger="click"
      visible={showModal || false}
    >
      <div className="mx-1" onClick={() => setShowModal(true)}>
        <IconHistory color="#C4C4C4" />
      </div>
    </Popover>
  );
};

const CheapestDifference = ({
  type,
  country,
  value,
  countriesAreDisplayed,
  showZeroAsEmpty = false,
}) => {
  const displayValue =
    (value !== 0 && value !== null) || !showZeroAsEmpty
      ? `${numberRound(value)} ${type == "margin" ? "%" : ""}`
      : "";
  return (
    <ImumTableTD
      country={country}
      countriesAreDisplayed={countriesAreDisplayed}
    >
      <nobr className={`${value && value < 0 ? "text-danger" : ""}`}>
        {displayValue}
      </nobr>
    </ImumTableTD>
  );
};

const StyledTd = ({ val, country, children, countriesAreDisplayed }) => {
  if (countriesAreDisplayed && !countriesAreDisplayed.includes(country))
    return null;
  return (
    <StyledTd2
      country={country}
      border_left={countriesAreDisplayed.at(0) == country}
      border_right={countriesAreDisplayed.at(-1) == country}
    >
      {children ? children : val ? val[country.toLowerCase()] : "-"}
    </StyledTd2>
  );
};
const StyledTd2 = styled.td`
  min-width: 100px;
  text-align: center;
  vertical-align: middle !important;
  background-color: ${(props) =>
    props.country == "LV"
      ? "rgba(200, 82, 96, 0.12)"
      : props.country == "LT"
      ? "rgba(255, 206, 49, 0.12)"
      : props.country == "EE"
      ? "rgba(66, 173, 226, 0.12)"
      : "rgb(0 150 136 / 14%)"};
  border-left: ${(props) =>
    props.border_left ? "1px solid rgb(191, 191, 191)" : "none"};
  border-right: ${(props) =>
    props.border_right ? "1px solid rgb(191, 191, 191)" : "none"};
`;

const FindShopPrice = ({ shop, country, data, countriesAreDisplayed }) => {
  if (countriesAreDisplayed && !countriesAreDisplayed.includes(country)) {
    return null;
  }
  const price = useMemo(() => {
    if (!data) return "-";
    if (data?.length == 0) return "-";
    const find_price = data.find(
      (d) => d.shop == shop && d.category == country
    );
    if (!find_price) return "-";
    if (find_price.active) return returnEuroString(find_price.price);

    return (
      <>
        {returnEuroString(find_price.price)}
        <Tooltip placement="top" title={`Out of stock`}>
          <span
            className="d-flex align-items-center justify-content-center px-1 mr-2"
            style={{
              // width: 16,
              height: 16,
              background: "rgba(217, 217, 217, 0.4)",
              borderRadius: 30,
              fontWeight: 600,
              fontSize: 9,
              color: "#C4C4C4",
            }}
          >
            OOS
          </span>
        </Tooltip>
      </>
    );
  }, []);

  return <nobr>{price}</nobr>;
};

const ImumExportLogs = ({ imum_export_logs = [] }) => {
  const [showMore, setShowMore] = useState(false);

  const logs = useMemo(() => {
    const reversed_logs = imum_export_logs.reverse();
    return removeDuplicates(reversed_logs.map(({ title }) => title)).map(
      (title) => {
        const errors = [];
        reversed_logs
          .filter((log) => log.title == title)
          .forEach((log) => {
            if (
              !errors.find(
                (s) =>
                  s.created_at.substr(0, 16) == log.created_at.substr(0, 16) &&
                  s.error == log.error
              )
            ) {
              errors.push(log);
            }
          });
        return {
          title,
          errors,
        };
      }
    );
  }, [imum_export_logs]);

  return (
    <div
      style={{
        minWidth: 180,
        maxWidth: 240,
      }}
    >
      {logs.map((imum_export_log, idx) =>
        idx > 0 && !showMore ? null : (
          <div key={imum_export_log.title} className="mb-1">
            <div className="d-flex align-items-center mb-1">
              <IconExclamation className="text-danger mr-1 text-base" />
              <span
                className="text-base"
                style={{
                  lineHeight: "14px",
                }}
              >
                {imum_export_log.title}
              </span>
            </div>
            {imum_export_log.errors.map((error) => (
              <React.Fragment key={error.created_at + "_" + error.error}>
                <p
                  className="text-silver text-sm mb-0"
                  style={{
                    lineHeight: "14px",
                  }}
                >
                  {error.created_at && prettyDateFormat(error.created_at)}
                </p>
                <p
                  className="text-sm mb-1"
                  style={{
                    lineHeight: "14px",
                  }}
                >
                  {error.error}
                </p>
              </React.Fragment>
            ))}
          </div>
        )
      )}
      {logs.length > 1 && (
        <div
          className="d-flex align-items-center text-primary text-sm cursor-pointer mt-1"
          onClick={() => setShowMore((prev) => !prev)}
        >
          <svg
            className="mr-1"
            xmlns="http://www.w3.org/2000/svg"
            width={18}
            height={18}
            viewBox="0 0 13 13"
            fill="none"
          >
            <g>
              <path
                d="M6.50004 11.9166C9.49166 11.9166 11.9167 9.49154 11.9167 6.49992C11.9167 3.50829 9.49166 1.08325 6.50004 1.08325C3.50842 1.08325 1.08337 3.50829 1.08337 6.49992C1.08337 9.49154 3.50842 11.9166 6.50004 11.9166Z"
                stroke="#03B0F7"
                strokeWidth="1.08333"
                strokeLinejoin="round"
              />
              {!showMore ? (
                <path
                  d="M8.9375 5.6875L6.5 8.125L4.0625 5.6875"
                  stroke="#03B0F7"
                  strokeWidth="1.08333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              ) : (
                <path
                  xmlns="http://www.w3.org/2000/svg"
                  d="M4.0625 7.3125L6.5 4.875L8.9375 7.3125"
                  stroke="#03B0F7"
                  strokeWidth="1.08333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              )}
            </g>
            <defs>
              <clipPath>
                <rect width="13" height="13" fill="white" />
              </clipPath>
            </defs>
          </svg>

          {!showMore ? "Show more failures" : "Show less failures"}
        </div>
      )}
    </div>
  );
};
